import React, {Component} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AuthActions from '../auth/AuthActions';
import LoginContainer from './Login';

@connect(
    state => ({
        lastUser: state.auth.lastUser,
        loggedOutMessage: state.auth.loggedOutMessage,
        authUser: state.authUser
    }),
    {...AuthActions}
)
export default class Logout extends Component {
    componentWillMount() {
        if(this.props.authUser)
            this.props.logout();
    }

    render() {
        var {loggedOutMessage, lastUser, dispatch} = this.props;

        return (
            <LoginContainer
                loggedOutMessage={loggedOutMessage}
                nextPath={"/"}
                dispatch={dispatch}
                lastUser={lastUser}
                {...bindActionCreators(AuthActions, dispatch)} />
        );
    }
}


// WEBPACK FOOTER //
// ./app/pages/Logout.js